/**
 * The enum indicates the reason for which the conversation is in the tombstone map.
 */
const enum TombstoneReasonType {
    Read, // Conversation marked read/unread
    RowRemove, // Conversation removed from the table. Delete, Move, Read in unread filter etc
}

export default TombstoneReasonType;
